// extracted by mini-css-extract-plugin
export default {"wrapper":"cardListEmployees_wrapper__ZomlS","remove":"cardListEmployees_remove__cly+g","removeIcon":"cardListEmployees_removeIcon__FTLnI","list":"cardListEmployees_list__01e-G"};